import React from 'react';
import HigProgressBar from '@hig/progress-bar';

const ProgressBar = (props) => {
  const progressBarStylesheet = (styles, themeData) => ({
    ...styles,
    wrapper: {
      ...styles.wrapper,
      backgroundColor: themeData["colorScheme.surfaceLevel100Color"],
      width: props.width || null
    }
  });

  return (
    <div className={props.className ? props.className : "pda-upload-progress-bar"} >
      <HigProgressBar stylesheet={progressBarStylesheet} percentComplete={props.percentComplete} />
    </div>
  )
}

export default ProgressBar;
